const win = global.window

export const window = typeof win !== undefined ? win : {} as Window
